var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sidebar-menu-container",
      attrs: { id: "photo-sidebar-menu" }
    },
    [
      _c("div", { staticClass: "lite-sidebar-main-label" }, [
        _vm._v("\n            Выберите дизайн\n        ")
      ]),
      _vm._v(" "),
      _c("DesignList", {
        attrs: { isLite: true },
        on: { selectDesign: _vm.selectDesign, openDesign: _vm.openDesign }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }